export default {
  getHead: () => {
    return [{ name: '사업장명' }, { name: 'ID(사번)' }, { name: '부서' }, { name: '구분' }, { name: '직종' }, { name: '직급' }, { name: '성명' }, { name: '최종 입사일' }, { name: '현보직일' }, { name: '연락처' }, { name: '총 교육이수 시간' }, { name: '퇴임일' }, ]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name // 사업장명
        case 1: return func.getContent(value).employee_id // 사번
        case 2: return func.getContent(value).targetCompany // 부서
        case 3: return func.getContent(value).job_category // 구분
        case 4: return func.getContent(value).employment_type // 직종
        case 5: return func.getContent(value).job_title // 직급
        case 6: return func.getContent(value).full_name // 성명
        case 7: return func.getContent(value).hire_date // 최종 입사일
        case 8: return func.getContent(value).current_position_date // 현보직일
        case 9: return func.getContent(value).contact_number // 연락처
        case 10: return func.getContent(value).temp // 총 교육이수 시간
        case 11: return func.getContent(value).retirement_date // 퇴임일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
      case '사업장명':
        returnData.push('content$body.stdInfo.field_name*%[:default_skw]%');
        break
      case 'ID(사번)':
        returnData.push('content$body.employee_id*%[:default_skw]%');
        break
      case '부서':
        returnData.push('content$body.targetCompany*%[:default_skw]%');
        break
      case '구분':
        returnData.push('content$body.job_category*%[:default_skw]%');
        break
      case '직종':
        returnData.push('content$body.employment_type*%[:default_skw]%');
        break
      case '직급':
        returnData.push('content$body.job_title*%[:default_skw]%');
        break
      case '성명':
        returnData.push('content$body.full_name*%[:default_skw]%');
        break
      case '최종 입사일':
        returnData.push('content$body.hire_date*%[:default_skw]%');
        break
      case '현보직일':
        returnData.push('content$body.current_position_date*%[:default_skw]%');
        break
      case '연락처':
        returnData.push('content$body.contact_number*%[:default_skw]%');
        break
      case '총 교육이수 시간':
        returnData.push('content$body.inputC_2*%[:default_skw]%');
        break
      case '퇴임일':
        returnData.push('content$body.retirement_date*%[:default_skw]%');
        break
    }
    return returnData
  },
}
